import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2B3329] text-[#E9E5DC] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#82917B] text-white font-serif text-lg">
              p
            </span>
            <span className="font-serif text-2xl text-[#FDFBF7]">
              The People Collective
            </span>
          </div>
          <p className="mt-5 max-w-md text-[#C9CCC1] leading-relaxed">
            A human-first HR consultancy based in Ontario. We work alongside
            your team to build policies, leadership, and labour relations
            practices that actually fit your people.
          </p>
        </div>

        <div>
          <p className="tpc-eyebrow text-[#A6B19E]">Explore</p>
          <ul className="mt-4 space-y-2">
            <li>
              <Link
                to="/about"
                className="hover:text-white transition-colors"
                data-testid="footer-link-about"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-white transition-colors"
                data-testid="footer-link-services"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/industries"
                className="hover:text-white transition-colors"
                data-testid="footer-link-industries"
              >
                Industries Served
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-white transition-colors"
                data-testid="footer-link-contact"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="tpc-eyebrow text-[#A6B19E]">Reach us</p>
          <ul className="mt-4 space-y-3 text-[#C9CCC1]">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-1 text-[#A6B19E]" />
              <span>Serving Ontario, Canada</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-1 text-[#A6B19E]" />
              <a
                href="mailto:thepeoplecollective@outlook.com"
                className="hover:text-white transition-colors"
                data-testid="footer-email"
              >
                thepeoplecollective@outlook.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-[#A6B19E]">
          <p data-testid="footer-copy">
            © {year} The People Collective. All rights reserved.
          </p>
          <p>Working alongside Ontario businesses to build stronger teams.</p>
        </div>
      </div>
    </footer>
  );
}
